import { MARQUEE_WORDS } from "../../data/content";

export const Marquee = () => {
  const row = [...MARQUEE_WORDS, ...MARQUEE_WORDS];
  return (
    <div data-testid="marquee-band" className="relative overflow-hidden border-y border-white/10 bg-[var(--forest-2)] py-6">
      <div className="marquee flex w-max gap-12 whitespace-nowrap">
        {[...row, ...row].map((w, i) => (
          <span key={i} className="font-display flex items-center gap-12 text-2xl italic text-[var(--cream)]/80 md:text-4xl">
            {w}
            <svg width="14" height="14" viewBox="0 0 24 24" className="text-[var(--gold)]" aria-hidden>
              <path fill="currentColor" d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" />
            </svg>
          </span>
        ))}
      </div>
    </div>
  );
};
